import { render } from "./AccountTypeUpdate.vue?vue&type=template&id=5c708ee2&scoped=true"
import script from "./AccountTypeUpdate.vue?vue&type=script&lang=js"
export * from "./AccountTypeUpdate.vue?vue&type=script&lang=js"

import "./AccountTypeUpdate.vue?vue&type=style&index=0&id=5c708ee2&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c708ee2"]])

export default __exports__